import { render, staticRenderFns } from "./subCategory.vue?vue&type=template&id=50c7ef03&scoped=true&"
import script from "./subCategory.vue?vue&type=script&lang=js&"
export * from "./subCategory.vue?vue&type=script&lang=js&"
import style0 from "./subCategory.vue?vue&type=style&index=0&id=50c7ef03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7ef03",
  null
  
)

export default component.exports